import config from '../../config';

import dateFormatter from './dateFormatter';

export const dueDateFormatter = (value?: string) => {
  return !value ? '' : dateFormatter(new Date(value).toISOString(), config.AMERICAN_DATE_FORMAT);
};
